import { dispatcher, api } from '@unicus/react-ui-kit';

export const MEDICALRECORDSECTION = 'MEDICALRECORDSECTION';
export const MEDICALRECORDSECTION_SORTING = 'MEDICALRECORDSECTION_SORTING';
export const MEDICALRECORDSECTION_SORTING_FINISHED =
  'MEDICALRECORDSECTION_SORTING_FINISHED';

export const updateSorting = (dataSource = []) => async (dispatch) => {
  const params = [];
  let ordination = 1;

  dataSource.forEach(({ id }) => {
    params.push({ id, ordination });
    ordination += 1;
  });

  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'record-sections',
    actionType: MEDICALRECORDSECTION_SORTING,
    payload: dataSource,
    effect: async () => api.put(`medical-record-sections/sorting`, params)
  });
};
